// outro
import {RegisterOptions, VuexModule} from 'vuex-class-modules';

export class OutroModule extends VuexModule {


  constructor(options: RegisterOptions) {
    super(options);

  }



}
